<template>
  <div class="header">
    <div class="container-fluid">
      <!-- Hearer  -->
      <div class="mt-4">
        <div class="card">
          <div class="card-body">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item fw-bolder">Master Data</li>
                <li class="breadcrumb-item">User</li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
      <!-- Card  -->
      <div class="card mt-5">
        <form ref="myFormSave" @submit.prevent="saveAdd()">
        <div class="card-header">
          <!-- Title -->
          <h4 class="card-header-title">Form Input User</h4>
          <b-button v-b-modal.modal-1 variant="primary" class="ml-1" @click="confirmAndCloseModal">
            Cancel
          </b-button>
          <b-button type="submit" variant="primary" class="ml-1">
            Save
          </b-button>
        </div>
        <div class="card-body">
          <div>
            <div class="row">
              <div class="col-6">
                <div class="form-group">
                  <label>Name</label>
                  <input name="name" type="text" class="form-control" v-model="payload.fullname" />
                  <span v-if="errorsField.fullname" class="text-danger">{{ errorsField.fullname }}</span>
                </div>
                <div class="form-group">
                  <label>Email</label>
                  <input name="email" type="text" class="form-control" v-model="payload.email" />
                  <span v-if="errorsField.email" class="text-danger">{{ errorsField.email }}</span>
                </div>
                <div class="form-group">
                  <label>Phone</label>
                  <input name="contact" type="text" class="form-control" v-model="payload.contact" />
                  <span v-if="errorsField.contact" class="text-danger">{{ errorsField.contact }}</span>
                </div>
                <div class="form-group">
                  <label>Role</label>
                  <v-select
                      :options="listRole"
                      v-model="payload.role_id"
                      :reduce="(e) => e.value"
                      placeholder="Select/Type Here..."
                      class="w-md-auto"
                  />
                  <span v-if="errorsField.role_id" class="text-danger">{{ errorsField.role_id }}</span>
                </div>
                <div class="form-group">
                  <label>Department</label>
                  <v-select
                      :options="listDivisi"
                      v-model="payload.department_id"
                      :reduce="(e) => e.value"
                      placeholder="Select/Type Here..."
                      class="w-md-auto"
                      multiple
                      @input="handleChangeDivisi"
                  />
                  <div class="mt-2">
                    <b-button size="sm" type="button" variant="primary" class="mt-1" @click="handleSelectAllDepartment">
                      Select All
                    </b-button>
                    <b-button size="sm" type="button" variant="primary" class="ml-1 mt-1" @click="handleClearSelectedAllDepartment">
                      Clear All Selected
                    </b-button>
                  </div>
                </div>
              </div>
              <div class="col-12 m-2">
                <b-card class="p-0 m-0">
                  <b-card-header class="p-0 m-0">
                    <div><b>Budget Plan</b></div>
                  </b-card-header>
                  <b-card-body class="p-0 m-0">
                    <table class="table table-bordered">
                      <thead>
                      <tr>
                        <td class="text-center" width="20">No.</td>
                        <td width="100">Title</td>
                        <!--                        <td width="100">Total</td>-->
                        <td width="100">Year</td>
                        <td width="100">Department</td>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-if="listBudgetPlan" v-for="(item, index) in listBudgetPlan" :key="index">
                        <td class="text-center">{{ index + 1 }}</td>
                        <td>{{ item.title }}</td>
                        <!--                        <td>{{ item.total }}</td>-->
                        <td>{{ item.year }}</td>
                        <td>{{ item?.fund_center?.department_name }}</td>
                      </tr>
                      </tbody>
                    </table>
                    <!--                        <vue-good-table :line-numbers="true" :columns="columns" :rows="listBudgetPlan" style-class="vgt-table border-0 table font-datatable" @on-page-change="onPageChange"
                                                           >
                                              &lt;!&ndash; Loading &ndash;&gt;
                                              <div slot="emptystate" class="text-center font-size-14">
                                                No data available
                                              </div>
                                            </vue-good-table>-->
                  </b-card-body>
                </b-card>
              </div>
            </div>
          </div>
        </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import ToggleSwitch from "@/components/ToggleSwitch.vue";
import index from "vuex";
import axiosIns from "@/api/axios";

export default {
  name: "ListUser",
  components: {ToggleSwitch},
  computed: {
    detail() {
      //return this.$store.getters["user/detail"];
    },
  },
  data() {
    return {
      payload: {
        fullname: "",
        email: "",
        role_id: "",
        contact: "",
        department_id: [],
      },
      divisi_id: "",
      department_id: "",
      role_id: "",
      id: "",
      isAdd: true,
      isLoading: false,
      listRole: [],
      listDivisi: [],
      listDepartement: [],
      listMember: [],
      selectedRole: null,
      paramName: null,
      paramEmail: null,
      paramRole: null,
      errorsField: {},
      listBudgetPlan: [],
    };
  },

  mounted() {
    this.getListRole();
    this.getListDivisi();
    this.role_id = localStorage.getItem('roles')
  },
  methods: {
    async getListRole() {
      try {
        const response = await axiosIns.get("/master-role");
        this.listRole = response.data.data.data.map(items => ({
          label: items.roles_name,
          value: items.id
        }));
      } catch (error) {
        console.error("Failed to fetch year options:", error);
      }

    },
    async getListDivisi() {
      try {
        const response = await axiosIns.get("/master-org-chart/divisi");
        this.listDivisi = response.data.data.map(items => ({
          label: items.name,
          value: items.id
        }));
      } catch (error) {
        console.error("Failed to fetch year options:", error);
      }

    },
    async getListDepartement(id, param) {
      try {
        this.listDepartement = [];
        const response = await axiosIns.get("/master-org-chart/"+ id);
        if(param === 'department'){
          if(response?.data?.data[0].parent){
            this.divisi_id = response?.data?.data[0].parent.id;
          }else{
            this.divisi_id = "";
          }
        }else{
          this.department_id = "";
        }
        this.listDepartement = response?.data?.data[0]?.childs.map(items => ({
          label: items.name,
          value: items.id
        }));
        this.listMember = response?.data?.data[0]?.members.map(items => ({
          label: items.fullname,
          value: items.id
        }));
      } catch (error) {
        console.error("Failed to fetch year options:", error);
      }

    },
    handleSelectAllDepartment() {
      this.listDivisi.forEach((value, index) => {
        this.payload.department_id.push(value.value)
      });
      const distinct = [...new Set(this.payload.department_id)];
      this.payload.department_id = distinct
    },
    handleClearSelectedAllDepartment() {
      this.payload.department_id = []
    },
    async handleChangeDivisi() {
      if (this.payload.department_id) {
        const org_chart_payload = {
          code: this.payload.department_id
        }
        const responseOrgChart = await axiosIns.post("/fund-center/by-list-code", org_chart_payload);
        this.listBudgetPlan = responseOrgChart.data.data;
      } else {
        this.listBudgetPlan = []
      }
    },
    btnBack() {
      this.$router.push(`/master-data/user`)
    },
    btnCancel() {
      this.payload = {
        fullname: "",
            email: "",
            role_id: "",
            contact: "",
            divisi: "",
            department: "",
            divisi_id: "",
            department_id: "",
      };
      this.divisi_id = "";
      this.department_id = "";
      this.role_id = "";
    },
    saveAdd() {
      try {
        this.isLoading = true;
        if (this.validate()) {
          let param = {
            fullname: this.payload.fullname
          };
          const response = axiosIns.post("/master-user/validasi-create", param).then(response => {
            if(response?.data?.data?.length){
              this.$swal("Error", "Name already exists", "error");
            }else{
              this.payload.role_id = this.payload.role_id > 0 ? this.payload.role_id : null;
              //this.payload.department_id = parseInt(this.department_id ? this.department_id : this.divisi_id);
              this.$store
                  .dispatch("user/CREATE_DATA", this.payload)
                  .then((resp) => {
                    this.$swal("Saved", "Your input has been saved", "success").then(
                        (resp) => {
                          this.isLoading = false;
                          this.$bvModal.hide("modal-1");
                          this.$router.push(`/master-data/user`)
                        }
                    );
                  });
            }
          })
        }
      } catch (error) {
        this.$swal("Error", "Error while add data", "error");
      }
    },
    confirmAndCloseModal() {
      this.$swal({
        title: 'Confirm Close?',
        text: 'Are you sure you want to close this page?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#00D97E',
        cancelButtonColor: '#E63757',
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
      }).then((result) => {
        if (result.isConfirmed) {
          this.$bvModal.hide('modal-1');
          this.$router.push(`/master-data/user`)
        }
      });
    },
    validate() {
      this.errorsField = {};
      if (!this.payload.fullname) {
        this.errorsField.fullname = "Name is required.";
      }
      if (!this.payload.role_id) {
        this.errorsField.role_id = "Role is required.";
      }
      if (this.payload.email) {
        if (!/\S+@\S+\.\S+/.test(this.payload.email)) {
          this.errorsField.email = "Email is invalid.";
        }
      }
      if (this.payload.contact) {
        const phoneRegex = /^(\+62|62|0)8[1-9][0-9]{6,9}$/;
        if (!phoneRegex.test(this.payload.contact)) {
          this.errorsField.contact = "Invalid phone number format.";
        }
      }
      return Object.keys(this.errorsField).length === 0;
    },
  },
};
</script>
